import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* ===== SCROLL STATE ===== */
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);

    const handleResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /* ===== LOCK BODY SCROLL (MOBILE MENU) ===== */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  /* ===== CLOSE MENU ON ROUTE CHANGE ===== */
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  /* ===== NAVIGATE + SCROLL ===== */
  const goToSection = (id) => {
    // Om vi inte är på startsidan: navigera till "/#id"
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      return;
    }

    // Om vi redan är på startsidan: scrolla direkt
    const el = document.getElementById(id);
    if (!el) return;

    el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  /* ===== When hash changes on home, scroll (fixar när man kommer från projekt) ===== */
  useEffect(() => {
    if (location.pathname !== "/") return;
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    // Vänta ett tick så att Home-sektionerna hinner rendera
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [location.pathname, location.hash]);

  return (
    <header className={`header ${isScrolled ? "scrolled" : ""}`}>
      {/* LOGO */}
      <a
        href="/#top"
        className="logo"
        onClick={(e) => {
          e.preventDefault();
          goToSection("top");
          setMenuOpen(false);
        }}
      >
        Wilma Edman
      </a>

      {/* HAMBURGER */}
      <button
        className="hamburger"
        onClick={() => setMenuOpen((v) => !v)}
        aria-label="Open menu"
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {/* OVERLAY */}
      <div
        className={`overlay ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* ===== SIDOMENY (MOBIL) ===== */}
      <nav className={`sideMenu ${menuOpen ? "active" : ""}`} aria-label="Mobile menu">
        <div className="sideMenuHeader">
          <span className="sideMenuHeading">Menu</span>

          <button
            className="closeBtn"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <div className="sideMenuLinks">
          <a
            href="/#work"
            onClick={(e) => {
              e.preventDefault();
              goToSection("work");
              setMenuOpen(false);
            }}
          >
            My Work
          </a>

          <a
            href="/#about"
            onClick={(e) => {
              e.preventDefault();
              goToSection("about");
              setMenuOpen(false);
            }}
          >
            About Me
          </a>

          <a
            href="/#contact"
            onClick={(e) => {
              e.preventDefault();
              goToSection("contact");
              setMenuOpen(false);
            }}
          >
            Contact
          </a>
        </div>
      </nav>

      {/* ===== DESKTOP NAV ===== */}
      <nav className="navbar" aria-label="Desktop menu">
        <a
          href="/#work"
          onClick={(e) => {
            e.preventDefault();
            goToSection("work");
          }}
        >
          My Work
        </a>

        <a
          href="/#about"
          onClick={(e) => {
            e.preventDefault();
            goToSection("about");
          }}
        >
          About Me
        </a>

        <a
          href="/#contact"
          onClick={(e) => {
            e.preventDefault();
            goToSection("contact");
          }}
        >
          Contact
        </a>
      </nav>
    </header>
  );
};

export default Navbar;



